module.exports = __webpack_public_path__ + "static/img/searchNotFound.de500216.png";